const VoucherDiscountType = {
  Percent: "percentage",
  Specific: "fixed",
};

export default VoucherDiscountType;
